import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { parse } from '../../../util/urlHelpers';
import { createResourceLocatorString } from '../../../util/routes';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import YearFilterPlain from '../../YearFilter/YearFilterPlain';

import css from './SearchPageStyles.module.css';

export const MIN_YEAR = 1700;
export const MAX_YEAR = new Date(Date.now()).getFullYear();

const YearFilter = () => {
  const intl = useIntl();
  const history = useHistory();
  const routes = useRouteConfiguration();
  const { location } = history;

  const currentQueryParams = parse(location?.search);

  return (
    <YearFilterPlain
      className={css.yearFilter}
      id="yearFilter"
      label={intl.formatMessage({ id: 'Global.year' })}
      queryParamNames="year"
      initialValues={{ year: currentQueryParams.year }}
      min={MIN_YEAR}
      max={MAX_YEAR}
      step={1}
      placeholder={intl.formatMessage({ id: 'Global.year' })}
      onSubmit={values => {
        const navigateTo = createResourceLocatorString(
          'SearchPage',
          routes,
          {},
          { ...currentQueryParams, year: values.year }
        );
        history.replace(navigateTo);
      }}
    />
  );
};

export default YearFilter;
